/**
 * Single source for Network Workbench + Agentic Networks sidebar row chrome.
 *
 * The sidebar is a FLAT WHITE surface (see ``Sidebar.jsx``), so selection can no longer be
 * signalled with "white fill + shadow" — that was only legible when the rail behind it was a
 * ``from-gray-50 to-gray-100`` gradient. On white it renders as no state at all.
 *
 * So the states INVERT: selection is now a blue TINT (semantic — these rows were already
 * blue-ringed and blue-texted when active), and hover is a light gray wash. Both read against
 * white, and selected still outranks hover.
 */
export const SIDEBAR_LIST_TITLE_CLASS =
  'font-medium text-sm text-gray-800 truncate flex-1 leading-5';

export function getSidebarListRowClassName(isSelected) {
  return `w-full text-left px-3 py-1 rounded-lg transition-all flex items-center gap-2 ${
    isSelected
      ? 'bg-blue-50 border border-blue-200'
      : 'hover:bg-gray-100'
  }`;
}
